console.log("v final");

function validateParamsUL() {
    async function clearCart(redirect) {
        await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
        console.log("nos vamos a", redirect)
        window.location.href = redirect;
    }
    /* GA4 purchase event — lee snapshot y dispara `purchase` antes de clearCart.
       Ver: cerebro/20-analytics-implementation-plan.md (Fase 5) */
    function firePurchaseEventIfPending() {
        try {
            if (!window.drwGAHelpers) return;
            var data = window.drwGAHelpers.readSnapshot();
            if (!data) return;
            var payload = {
                transaction_id: data.transaction_id,
                value: data.value,
                currency: data.currency,
                tax: data.tax,
                shipping: data.shipping,
                items: data.items
            };
            if (typeof gtag === 'function') {
                gtag('event', 'purchase', payload);
                gtag('event', 'close_convert_lead', { value: payload.value, currency: payload.currency });
                console.log('[GA4] purchase + close_convert_lead fired:', payload.transaction_id, payload.value, payload.currency);
            }
            window.drwGAHelpers.clearSnapshot();
        } catch (e) { console.error('[GA4 purchase]', e); }
    }
    try {
        var params = new URLSearchParams(window.location.search);
        var shouldClear = params.get("order") === "ul-complete";
        const urlRedirect = params.get("redirect") || '/';
        if (shouldClear) {
            firePurchaseEventIfPending(); /* ANTES de clearCart */
            clearCart(urlRedirect);
        }
    } catch (e) {
        console.error(e);
    }

}
function clearElementsUL() {
    const sectionCalculator = document.getElementById("shipping-calculator");
    if (sectionCalculator) {
        sectionCalculator.style.display = 'none';
        const sections = document.getElementsByClassName("cart-order-note");
        const note = sections[0];
        if (note) {
            note.style.display = 'none';
        }
    }

}
async function activeCheckoutUL() {
    console.log("activeCheckout")
    const URL_HOST = 'https://apis.unalukaglobal.com';
    const API_CREATE_ORDER = '/business/ecommerce/create-order';
    const bodyContent = document.getElementById("body-content");
    if (bodyContent) {
        bodyContent.classList.add('new-cart');
    }
    function showWarningTerms(show) {

        const listWarnings = document.querySelectorAll(".terms-warning");
        listWarnings.forEach(btn => {
            if (show) {
                btn.style.display = "block";
            } else {
                btn.style.display = "none";
            }
        });
    }
    async function sendCart(gateway = '') {
        const elementCheckoutD = document.getElementById("agree-desktop");
        const elementCheckoutM = document.getElementById("agree-mobile");
        if (!elementCheckoutD?.checked && !elementCheckoutM.checked) {
            showWarningTerms(true);
            return;
        }
        showWarningTerms(false);
        //console.log('elementCheckout.value', elementCheckout.elementCheckoutD);
        //return;
        const res = await fetch('/cart.js', {
            headers: { 'Accept': 'application/json' },
            cache: 'no-store',
            credentials: 'same-origin'
        });
        const cart = await res.json();
        /* GA4 begin_checkout + snapshot para purchase event cuando vuelva del gateway.
           Ver: cerebro/20-analytics-implementation-plan.md (Fases 2 y 5) */
        if (window.drwGAHelpers && cart && cart.items && cart.items.length) {
            try { window.drwGAHelpers.fireBeginCheckout(cart); } catch (e) { console.error('[GA4 begin_checkout]', e); }
        }
        const sid_tracking = localStorage.getItem("sid_tracking");
        let vendor = '';
        if (sid_tracking) {
            try {
                const data = JSON.parse(sid_tracking);
                if (data.sid) {
                    vendor = data.sid;
                }

            } catch (error) {

            }
        }
        const createDTO = {
            cartToken: cart.token,
            domain: window.location.hostname,
            gateway,
            vendor
        };
        try {
            const response = await fetch(`${URL_HOST}${API_CREATE_ORDER}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(createDTO),
            });

            if (!response.ok) {
                throw new Error('Failed to create order');
            }

            const result = await response.json();
            if (result.link) {
                window.location.href = result.link + '&gateway=' + gateway;
            }
        } catch (error) {
            console.error('Error creating order:', error);
        }
    }
    const responseCart = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' },
        cache: 'no-store',
        credentials: 'same-origin'
    });
    const currentCart = await responseCart.json();
    console.log("currentCart", currentCart);
    const listBtnCash = document.querySelectorAll(".btn-cash");
    const listBtnYape = document.querySelectorAll(".btn-yape");
    const listBtnAlignet = document.querySelectorAll(".btn-buy-alignet");
    const listBtnBuyShopify = document.querySelectorAll(".btn-buy-shopify");
    listBtnBuyShopify.forEach(btn => {
        /*
        btn.querySelectorAll(".labelCheckout").forEach(label => {
          label.innerHTML = 'Pagar con ';
        });
        */
        btn.addEventListener("click", (event) => {
            event.preventDefault();

            sendCart("payme");

        });
    });
    const priceCash = Math.round(currentCart.items_subtotal_price / 100);
    listBtnCash.forEach((btn) => {

        btn.innerHTML = "Depósito bancario <b>S/" + priceCash + "</b>";
        btn.addEventListener("click", (event) => {
            event.preventDefault();
            console.log("pagando en cash");
            sendCart("deposit");

        });

    });
    listBtnYape.forEach((btn) => {

        if (currentCart.original_total_price > 200000) {
            console.log('quitando yapee');
            btn.classList.remove("btn-active");
            //btn.style.display = "none !important";
        } else {
            btn.classList.add("btn-active");
        }

        btn.addEventListener("click", (event) => {
            event.preventDefault();
            console.log("pagando en btnYape");
            sendCart("payme&method=yape");

        });
    });
};

// Obtener el parámetro "sandbox" de la URL y guardarlo en localStorage (si existe)
function syncSandboxFromQuery() {
    try {
        const params = new URLSearchParams(window.location.search);
        const sandbox = params.get('sandbox');
        console.log('value sandbox:', sandbox);

        if (sandbox !== null) {
            localStorage.setItem('sandboxUL', sandbox);
            console.log("seitem sandbox a:", sandbox);

        }
    } catch (e) {
        console.error(e);
    }
}
syncSandboxFromQuery();

/* GA4 view_cart — dispara cuando el usuario carga la página /cart legacy.
   Ver: cerebro/20-analytics-implementation-plan.md (Fase 2) */
function fireViewCartLegacy() {
    try {
        if (!window.drwGAHelpers) return;
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            if (!cart || !cart.items || !cart.items.length) return;
            window.drwGAHelpers.fireEvent('view_cart', {
                value: Number(cart.total_price || 0) / 100,
                items: cart.items.map(window.drwGAHelpers.lineItemToGaItem).filter(Boolean)
            });
          })
          .catch(function() {});
    } catch (e) {}
}

document.addEventListener("DOMContentLoaded", function () {
    //console.log("✅ El DOM ya está listo");
    console.log('parametro sandbox:', localStorage.getItem("sandboxUL"));
    console.log('path:', window.location.pathname);

    /* CRÍTICO: validateParamsUL debe correr en TODAS las páginas, no solo /cart,
       porque el gateway externo redirige a `/?order=ul-complete&redirect=/`
       y el usuario aterriza en la home, no en /cart.
       Antes estaba dentro del guard `if pathname === '/cart'` → purchase event no disparaba. */
    validateParamsUL();

    if (window.location.pathname === '/cart') {
        activeCheckoutUL();
        clearElementsUL();
        fireViewCartLegacy();
    }
});


